var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'object-assign';
import Promise from 'promise-polyfill';
// To add to window
if (!window.Promise) {
    window.Promise = Promise;
}
import "whatwg-fetch";
import { colorbrewer } from './assets/colorbrewer';
import * as d3 from 'd3';
import * as _ from 'lodash';
//
// Data setup
//
var maps, data;
var start_year = 1917;
var end_year = 2016;
var classifications = [100, 500, 1000, 2000, 5000, 15000, Number.POSITIVE_INFINITY]; // ..and beyond
var explanations = ['alle 100', '100 - 500', '500 - 1 000', '1 000 - 2 000', '2 000 - 5 000', '5 000 - 15 000', 'yli 15 000'];
var map_names = [
    'data/Laanit_1917_1920_1.geojson',
    'data/Laanit_1921_1937_2.geojson',
    'data/Laanit_1938_1940_3.geojson',
    'data/Laanit_1941_1944_4.geojson',
    'data/Laanit_1945_1947_5.geojson',
    'data/Laanit_1948_1959_6.geojson',
    'data/Laanit_1960_1994_7.geojson',
    'data/Maakunnat_8.geojson'
];
var map_ranges = [1921, 1938, 1941, 1945, 1948, 1960, 1995, Number.POSITIVE_INFINITY];
var suomenlinna = "#F5A3C7";
var colors = colorbrewer.Blues[7];
var darker = function (color) { return d3.rgb(color).darker(); };
function get_map_for_year(year) {
    var x;
    _.find(map_ranges, function (range, index) {
        if (year < range) {
            x = map_names[index];
            return true;
        }
    });
    return x;
}
//
// Fetching maps and data
//
function loader() {
    return __awaiter(this, void 0, void 0, function () {
        var m, data, i, name_1, res, _a, _b, r2, laanit_text, laanit_list, laanit, r3, maakunnat_text, maakunnat_list, maakunnat;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    m = {};
                    data = {};
                    i = 0;
                    _c.label = 1;
                case 1:
                    if (!(i < map_names.length)) return [3 /*break*/, 5];
                    name_1 = map_names[i];
                    return [4 /*yield*/, fetch(name_1)];
                case 2:
                    res = _c.sent();
                    _a = m;
                    _b = name_1;
                    return [4 /*yield*/, res.json()];
                case 3:
                    _a[_b] = _c.sent();
                    _c.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 1];
                case 5: return [4 /*yield*/, fetch('data/laanit.csv')];
                case 6:
                    r2 = _c.sent();
                    return [4 /*yield*/, r2.text()];
                case 7:
                    laanit_text = _c.sent();
                    laanit_list = [];
                    d3.dsvFormat(';').parse(laanit_text, function (d) { return laanit_list.push(d); });
                    laanit = {};
                    laanit_list.forEach(function (item) {
                        var y = item["VUOSI"];
                        laanit[y] = _.omit(item, ['VUOSI', 'Yhteensä', ""]);
                        laanit[y]['map'] = get_map_for_year(y);
                    });
                    return [4 /*yield*/, fetch('data/maakunnat.csv')];
                case 8:
                    r3 = _c.sent();
                    return [4 /*yield*/, r3.text()];
                case 9:
                    maakunnat_text = _c.sent();
                    maakunnat_list = [];
                    d3.dsvFormat(';').parse(maakunnat_text, function (d) { return maakunnat_list.push(d); });
                    maakunnat = {};
                    maakunnat_list.forEach(function (item) {
                        var y = item["VUOSI"];
                        maakunnat[y] = _.omit(item, ['VUOSI', 'Yhteensä', ""]);
                        maakunnat[y]['map'] = get_map_for_year(y);
                    });
                    Object.assign(data, laanit);
                    Object.assign(data, maakunnat);
                    return [2 /*return*/, { maps: m, data: data }];
            }
        });
    });
}
//
// Map setup
//
function createMap(geojson, data) {
    var classes = {};
    Object.keys(data).forEach(function (key) {
        // Empty data for this space
        if (data[key] === "") {
            classes[key] = null;
            return;
        }
        for (var i = 0; i < classifications.length; i++) {
            if (Number(data[key]) < classifications[i]) {
                classes[key] = i;
                break;
            }
        }
    });
    var width = 350, height = 500;
    var svg = d3.select("#viz svg");
    svg.selectAll("*").remove();
    var projection = d3.geoTransverseMercator().fitSize([width, height], geojson)
        .rotate([-27, -65, 0])
        .translate([(width / 2) + 30, height / 2])
        .scale([2802]);
    var path = d3.geoPath().projection(projection);
    var g = svg.append("g")
        .style("stroke-width", "1.5px");
    g.selectAll('path')
        .data(geojson.features)
        .enter()
        .append('path')
        .attr('d', path)
        .style("fill", function (d) {
        if (d.properties.nimi === 'HELSINKI')
            return suomenlinna; // Suomenlinna
        else if (classes[d.properties.nimi] !== null) {
            return colors[classes[d.properties.nimi]];
        }
    })
        .style("stroke-width", function (d) { return d.properties.nimi === 'HELSINKI' ? "3" : "1"; })
        .style("stroke", function (d) {
        switch (d.properties.nimi) {
            case 'HELSINKI':
                return darker(suomenlinna);
            case 'UUDENMAAN LÄÄNI':
                return "none";
            default:
                return "white";
        }
    })
        .append("title").text(function (d) {
        if (d.properties.nimi === 'HELSINKI')
            return "suomenlinna"; // Suomenlinna
        else if (classes[d.properties.nimi] !== null) {
            return d.properties.nimi + " " + data[d.properties.nimi];
        }
    });
}
var maps = {};
var data = {};
function render(year) {
    return __awaiter(this, void 0, void 0, function () {
        function advancer(num) {
            if (animate && num < end_year) {
                mySlider.setValue(num, true, true);
                setTimeout(function () {
                    advancer(num + 1);
                }, 500);
            }
        }
        var res, stuff, years, mySlider, animate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loader()];
                case 1:
                    res = _a.sent();
                    maps = res["maps"];
                    data = res["data"];
                    stuff = _.flatten([
                        start_year,
                        _.range(start_year, end_year).filter(function (v) { return v % 10 === 0; }),
                        end_year
                    ]);
                    years = _.range(start_year, end_year);
                    mySlider = new Slider("input#slider", {
                        ticks: stuff,
                        ticks_labels: stuff,
                        ticks_positions: [0, 5, 15, 25, 35, 45, 55, 65, 75, 85, 93, 100],
                        min: start_year,
                        max: end_year
                    });
                    mySlider.on('change', function (v) { return set_year(v.newValue); });
                    d3.select('#animate button')
                        .on('click', function () {
                        if (animate) {
                            animate = false;
                            d3.select(this).text('Animaatio');
                        }
                        else {
                            animate = true;
                            d3.select(this).text('Stop');
                        }
                        advancer(year);
                    });
                    make_legend();
                    createMap(maps[data[year]["map"]], data[year]);
                    return [2 /*return*/];
            }
        });
    });
}
// Legend
function make_legend() {
    d3.select('div#legend')
        .selectAll('span')
        .data(colors)
        .enter()
        .append('span')
        .attr('style', function (d) { return 'background-color:' + d; })
        .attr('class', 'color')
        .append('span')
        .attr('class', 'label')
        .text(function (d, i) { return explanations[i]; });
}
function set_year(year) {
    createMap(maps[data[year]["map"]], data[year]);
}
render(start_year);



// WEBPACK FOOTER //
// ./viz.js